






import { Component, Prop, Vue } from 'vue-property-decorator';
import FromNow from '@/browser/atoms/FromNow.vue';

@Component({
  components: {
    FromNow,
  },
})
export default class RoomCreatedAtChip extends Vue {
  @Prop()
  private createdAt!: number;
}
